import template from './range.html';
import './range.less';
import * as _ from 'lodash';

export default angular.module('cian.newbuild.filter.serpRange', [])
  .directive('cianSerpRange', () => {
    return {
      restrict: 'E',
      template,
      scope: {},
      bindToController: {
        source: '=',
        rangeMin: '@?',
        rangeMax: '@?',
      },
      controller: function() {
        const ctrl = this;

        ctrl.inputs = [{
          key: 'gte',
          placeholder: 'от',
        }, {
          key: 'lte',
          placeholder: 'до',
        }];

        ctrl.limitConfig = _.omitBy({
          min: ctrl.rangeMin,
          max: ctrl.rangeMax,
        }, _.isUndefined);
      },
      controllerAs: 'serpRange',
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/range/range.dir.js